import './styles.scss'
import '../accordion-item/styles.scss'
import { onDocumentReady } from 'scripts/util/events'

const AKK_CLASS = '.dhsv-akkordeon'
onDocumentReady(() => {
  const target = document.querySelector('body')

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      const akkordeons = Array.from(document.querySelectorAll(AKK_CLASS))
      if (akkordeons.length > 0) {
        akkordeons.forEach(handleAkkordeon)
      }
    })
  })

  // Konfiguration des Observers: alles melden - Änderungen an Daten, Kindelementen und Attributen
  const config = {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  }

  // eigentliche Observierung starten und Zielnode und Konfiguration übergeben
  observer.observe(target, config)
})

const handleAkkordeon = item => {
  if (item.classList.contains('initialized')) {
    return false
  }

  const props = JSON.parse(item.getAttribute('data-props'))
  const children = Array.from(item.querySelectorAll(`${AKK_CLASS}--item`))
  const allOpenButton = item.querySelector(`button.show-all-button`)
  let state = children.map((x, i) => i === props.selected) // props.selected is only in block json
  let targetId = window.location.hash.slice(1)
  let target = document.getElementById(targetId)

  item.classList.add('initialized')

  const renderState = () => {
    children.forEach((child, key) => {
      if (child.getAttribute('data-initial-open') === 'true') {
        state[key] = true
        child.removeAttribute('data-initial-open') // Ensure it's only used once
      }
      // check anchor in the url
      if (targetId !== '' && target && target === child) {
        state[children.indexOf(target)] = true
        targetId = ''
      }

      if (state[key]) {
        child.classList.add('open')
        child.setAttribute('aria-expanded', true)
      } else {
        child.classList.remove('open')
        child.setAttribute('aria-expanded', false)
      }

      animateHeight(child, state[key])

      if (allOpenButton) {
        renderAllOpenButton()
      }
    })
  }

  const renderAllOpenButton = () => {
    const allClosed = !state.includes(true)
    const text = allOpenButton.getAttribute(
      allClosed ? 'data-open' : 'data-close'
    )
    allOpenButton.querySelector(':scope > span').innerHTML = text
    if (!allClosed) {
      allOpenButton.classList.add('open')
    } else {
      allOpenButton.classList.remove('open')
    }
  }

  let pageLoaded = false
  window.addEventListener('load', () => {
    pageLoaded = true
  })

  const animateHeight = (child, open = true) => {
    const body = child.querySelector(`${AKK_CLASS}--item__body`)
    body.style.transition = 'height 0.25s ease'
    const height = body.querySelector(`:scope > div`).clientHeight
    let slug = child.getAttribute('id')
    if (open) {
      if (slug !== '' && pageLoaded) {
        history.pushState({}, '', `#${slug}`)
      } else if (slug === '' && pageLoaded) {
        history.replaceState({}, document.title, window.location.pathname)
      }
      body.style.height = `${height}px`
      setTimeout(() => {
        body.style.height = 'auto'
      }, 250)
    } else if (parseFloat(body.style.height) !== 0) {
      if (pageLoaded) {
        history.replaceState({}, document.title, window.location.pathname)
      }
      body.style.transition = 'none'
      body.style.height = height + 'px'
      body.style.transition = 'height 0.25s ease'
      setTimeout(() => {
        body.style.height = 0
      }, 50)
    }
  }

  const handleChildClick = (child, key) => {
    state = state.map((x, i) => {
      const isThisOpen = x && key === i
      return isThisOpen ? false : props.onlyOne ? i === key : !x ? i === key : x
    })

    renderState()
    animateHeight(child, state[key]) // Ensure animateHeight is called with the correct child
  }

  const handleShowAll = () => {
    state = state.map(() => !allOpenButton.classList.contains('open'))
    renderState()
  }

  renderState()

  children.forEach((child, key) => {
    if (!child.classList.contains('initialized')) {
      child.classList.add('initialized')

      const header = child.querySelector('.item-header')
      if (header) {
        header.addEventListener('click', () => handleChildClick(child, key))
      }
    }
  })

  if (allOpenButton && !allOpenButton.classList.contains('initialized')) {
    allOpenButton.classList.add('initialized')
    allOpenButton.addEventListener('click', handleShowAll)
  }
}
